<template>
  <div
    class="px-6 py-4"
    :class="props.class"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
interface Props {
  class?: string
}

const props = defineProps<Props>()
</script>
